<template>
  <div>
    <login-header v-bind="headerInfo" :userDisplayFlag="false"></login-header>
    <div class="content">
      <img
        src="https://img-shop.qmimg.cn/s1001016/images/2020/05/14/3fc16af12e6f2040.png"
        width="100%"
        draggable="false"
      />
    </div>
    <login-footer :description="desc"></login-footer>
  </div>
</template>

<script>
import loginHeader from '../header'
import loginFooter from '../footer'
import qs from 'qs'

export default {
  components: {
    loginHeader,
    loginFooter
  },
  data() {
    return {
      headerInfo: {
        type: '操作步骤',
        userDisplayFlag: true,
        userName: '',
        logo: ''
      },
      desc: ''
    }
  },
  created() {
    const mobile = localStorage.getItem('mobile')
    this.headerInfo.userName = mobile

    this.loginInfo = qs.parse(localStorage.getItem('xdata'))
    this.headerInfo.logo = this.loginInfo.logo
    this.desc = this.loginInfo.desc
  }
}
</script>